<template>
  <el-card class="user-content-panel client-info">
    <div slot="header">
      <span class="panel-header">人员管理</span>
    </div>
    <el-row class="search-row" :gutter="20" style="margin-bottom: 0">
      <el-col :span="6">
        <el-input v-model="queryParam.clientName" class="price-input" placeholder="请输入名称"></el-input>
      </el-col>
      <el-col :span="8">
        <el-input v-model="queryParam.employeeCode" class="price-input" placeholder="请输入员工编码"></el-input>
      </el-col>
      <el-col :span="5">
        <el-select v-model="queryParam.employeeLevel" placeholder="请选择员工级别" filterable clearable style="width:100%">
          <el-option
            v-for="item in roleList"
            :label="item.name"
            :value="item.level"
            :key="item.level"
          />
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-select v-model="queryParam.clientStatus" placeholder="请选择员工状态" filterable clearable style="width:100%">
          <el-option
            v-for="item in clientStatusList"
            :label="item.value"
            :value="item.key"
            :key="item.key"
          />
        </el-select>
      </el-col>
    </el-row>
    <el-row class="search-row" :gutter="20" style="padding-top: 0">
        <el-col :span="6">
          <el-input v-model="queryParam.lineManagerName" class="price-input" placeholder="请输入上级名称"></el-input>
        </el-col>
        <el-col :span="8">
          <el-input v-model="queryParam.lineManagerCode" class="price-input" placeholder="请输入上级编码"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="danger" class="btn-red" size="medium" icon="el-icon-search" @click="handleSearch()">搜索</el-button>
        </el-col>
        <el-col :span="3">
          <el-button type="danger" class="btn-red" size="medium" @click="handleReset()">重置</el-button>
        </el-col>
    </el-row>

    <el-table :data="clientInfoList" class="order-data-table ie-table"  v-loading="listLoading">
      <el-table-column label="名称" prop="clientName"/>
      <el-table-column label="员工编码" prop="employeeCode"/>
      <el-table-column label="员工级别" prop="employeeLevelName"/>
      <el-table-column label="上级名称" prop="lineManagerName"/>
      <el-table-column label="上级编码" prop="lineManagerCode"/>
      <el-table-column label="状态" prop="clientStatusName"/>
      <!-- <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <div style="line-height: 35px;">
            <el-button type="danger" class="btn-red" size="mini" @click="handleModify(scope.row)">修改</el-button>
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <el-dialog title="人员信息修改" :visible.sync="dialogVisible" :close-on-click-modal="false" width="50%">
      <el-form ref="clientForm" :model="clientForm" label-width="120px" size="small" class="address-form">
        <el-row>
          <el-col :span="20">
            <el-form-item label="修改员工级别">
              <el-radio-group v-model="clientForm.employeeLevel">
                <el-radio
                  v-for="(item, index) in roleList"
                  :label="item.level"
                  :key="index"
                  @click.native.prevent="handleLevelChange(item.level)">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="20">
            <el-form-item label="修改员工上级">
              <el-input v-model="clientForm.parentEmployeeCode" placeholder="请输入要修改成的上级员工编码"/>
            </el-form-item>
          </el-col> -->
          <el-col :span="20">
            <el-form-item label="修改员工状态">
              <el-select v-model="clientForm.clientStatus" style="width:80%;" clearable placeholder="请选择员工状态">
                <el-option
                  v-for="item in clientStatusList"
                  :label="item.value"
                  :value="item.key"
                  :key="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="btn-orange-plain" @click="submitUpdate">确 定</el-button>
        <el-button class="btn-grey" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <div class="pag-row" v-if="clientInfoList && clientInfoList.length">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="queryParam.page"
        :page-size="queryParam.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-card>
</template>

<script>
import userApi from '@/api/user'
import { mapState } from 'vuex'
export default {
  name: 'client-list',
  created () {
    this.queryClientList()
    this.$store.dispatch('getDictByName', 'clientStatusMap')
  },
  data () {
    return {
      roleList: [{
        name: 'M1',
        level: 10
      }, {
        name: 'M2',
        level: 20
      }, {
        name: 'M3',
        level: 30
      }],
      clientInfoList: [],
      dialogVisible: false,
      clientForm: {
        employeeLevel: '',
        parentEmployeeCode: '',
        clientStatus: ''
      },
      total: 0,
      queryParam: {
        page: 1,
        pageSize: 10,
        clientName: '',
        employeeCode: '',
        lineManagerName: '',
        lineManagerCode: '',
        clientStatus: ''
      },
      clientId: '',
      listLoading: false
    }
  },
  computed: {
    ...mapState({
      clientStatusList: state => state.base.clientStatusMap
    })
  },
  methods: {
    // 获取公告列表
    queryClientList () {
      this.listLoading = true
      userApi.queryClientList(this.queryParam).then(res => {
        if (res.data.resultCode === '0') {
          this.listLoading = false
          this.clientInfoList = res.data.resultData.lowClient
          this.total = res.data.resultData.pageInfo.totalCounts
        }
      })
    },
    handleModify (row) {
      this.clientForm = this.$options.data().clientForm
      this.dialogVisible = true
      this.clientId = row.clientId
    },
    handleLevelChange (level) {
      level === this.clientForm.employeeLevel ? this.clientForm.employeeLevel = '' : this.clientForm.employeeLevel = level
    },
    submitUpdate () {
      const param = {
        clientId: this.clientId,
        employeeLevel: this.clientForm.employeeLevel,
        parentEmployeeCode: this.clientForm.parentEmployeeCode,
        clientStatus: this.clientForm.clientStatus
      }
      userApi.updateClientStatus(param).then(res => {
        if (res.data.resultCode === '0') {
          this.dialogVisible = false
          this.$message.success('人员信息修改成功')
          this.queryClientList()
        }
      })
    },
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryClientList()
    },
    handleSearch () {
      this.queryClientList()
    },
    handleReset () {
      this.queryParam = this.$options.data().queryParam
      this.queryClientList()
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-table {
  width: 96%;
  margin: 0 auto;

  .notice-subject {
    cursor: pointer;

    &:hover {
      color: $base-red;
    }
  }
}
.pag-row {
  padding-bottom: 20px;
}
.search-row {
  margin-bottom: 15px;
  padding: 20px 20px 0 20px;
  line-height: 36px;
  .el-col {
    padding-bottom: 10px;
  }
}
.el-select {
  width: 125px;
  height: 36px;
}
.el-button {
  height: 36px;
  margin-left: 10px;
}
.feature-row {
  margin-bottom: $content-middle;
}
.order-data-table{
  padding: 20px;
}
</style>
